var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment"},[_c('vtextarea',{staticClass:"comment__area",attrs:{"border":false,"placeholder":_vm.$tr('onlineInterview.room.comment')},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }